const ENV = {
  environment: 'dev',
  clientId: 'd324d503-0127-4a85-a547-d9f2439ffeae',
  apis: {
    authentication: '/api/1/authenticate',
    getUserByAccessToken: '/api/1/users/me',
    resetPasswordByEmail: '/api/1/resetPassword',
    signup: '/api/1/users',
    logout: '/api/1/logout'
  },
  message: {
    
  },
  // Only production loads a tag container. Outside production gtmId stays null and the app logs
  // what it would have pushed instead (enableQaOutput). See PAE-2465.
  gtmId: null,
  enableQaOutput: true,
  facebook: {
    fbAppId: '287143108028717',
    fbVersion: 'v2.9',
  },
  //google_clientID: '1079494363322-lahktp5qtiskm0bm1slkurebmp7acgc8.apps.googleusercontent.com',
  //google_clientId: '1079494363322-0ij55rptv0aug7f321j2tr0gpdmn94g0.apps.googleusercontent.com',
  google_clientId: '1079494363322-lahktp5qtiskm0bm1slkurebmp7acgc8.apps.googleusercontent.com',
  apple_signin_redirect: 'https://tinybeans.com/api/1/oauth2/apple/login',
  apple_signin_returnTo: 'http://localhost:8080/#/login',
  apple_clientId: 'com.tinybeans.web.staging',
};

if(window) {
  if(window.location.host === 'tinybeans.com') {
    //production
    ENV.environment = 'production';
    ENV.gtmId = 'GTM-PT8VSZ';
    ENV.enableQaOutput = false;
    ENV.facebook.fbAppId = '358245560878128';
    ENV.apple_signin_redirect = 'https://tinybeans.com/api/1/oauth2/apple/callback';
    ENV.apple_signin_returnTo = 'https://tinybeans.com/app/#/login/apple';
    ENV.apple_clientId = 'com.tinybeans.web';
  } else if(window.location.host === 'onada.tinybeans.com' || window.location.host === 'hinata.tinybeans.com' || window.location.origin != "http://localhost:8080") {
    //staging
    ENV.environment = 'staging';
    ENV.facebook.fbAppId = '197498313761540';
    ENV.apple_signin_redirect = 'https://hinata.tinybeans.com/api/1/oauth2/apple/callback';
    ENV.apple_signin_returnTo = 'https://onada.tinybeans.com/app/#/login/apple';
    ENV.apple_clientId = 'com.tinybeans.web.staging';
  } else if (window.location.origin === "http://localhost:8080") {
    ENV.apis.authentication = 'https://hinata.tinybeans.com/api/1/authenticate';
    ENV.apis.getUserByAccessToken = 'https://hinata.tinybeans.com/api/1/users/me';
    ENV.apis.resetPasswordByEmail = 'https://hinata.tinybeans.com/api/1/resetPassword';
    ENV.apis.signup = 'https://hinata.tinybeans.com/api/1/users';
    ENV.apis.logout = 'https://hinata.tinybeans.com/api/1/logout';
  }
}

export default ENV;

//note,
//Ember has nonprod environment